import { render } from "./FileTreePrimeVue.vue?vue&type=template&id=1c1e746c&scoped=true"
import script from "./FileTreePrimeVue.vue?vue&type=script&lang=js"
export * from "./FileTreePrimeVue.vue?vue&type=script&lang=js"

import "./FileTreePrimeVue.vue?vue&type=style&index=0&id=1c1e746c&scoped=true&lang=css"
import "./FileTreePrimeVue.vue?vue&type=style&index=1&id=1c1e746c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1e746c"]])

export default __exports__